module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_t-monet.8900571d5e8ff2408b7e6ab30f65f89b.png";